module.exports = __webpack_public_path__ + "img/exit-icon.5396b953.svg";